type BrandLogoVariant = "official" | "horizontal" | "reduced" | "symbol" | "light" | "dark";

const assets: Record<BrandLogoVariant, string> = {
  official: "/branding/logo-oficial.png",
  horizontal: "/branding/logo-horizontal.png",
  reduced: "/branding/logo-reduzida.png",
  symbol: "/branding/simbolo.png",
  light: "/branding/logo-fundo-claro.png",
  dark: "/branding/logo-fundo-escuro.png"
};

export function BrandLogo({ variant = "horizontal", className = "", alt }: { variant?: BrandLogoVariant; className?: string; alt?: string }) {
  const description = variant === "symbol" ? "Símbolo da Chiorato & Correa Engenharia" : "Chiorato & Correa Engenharia";
  return <img className={className} src={assets[variant]} alt={alt ?? description} draggable={false} />;
}
